import { render, staticRenderFns } from "./inventory-import.vue?vue&type=template&id=5f7c2a68"
import script from "./inventory-import.vue?vue&type=script&lang=js"
export * from "./inventory-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports